// Function component (presentational):

import React from 'react'

import LayoutWrapper from '../shared/styledComponents/page/LayoutWrapper'
import PageWrapper from '../shared/styledComponents/page/PageWrapper'

import LibraContainer from '../libra/LibraStatefulContainer'

import NavContainer from '../nav/NavContainer'

import ScannerContainer from './ScannerStatefulContainer'

const ScannerView = () => (
	<LayoutWrapper>
		<NavContainer sleekNav />

		<PageWrapper style={{ paddingBottom: 0 }}>
			<ScannerContainer />
		</PageWrapper>

		<LibraContainer />
	</LayoutWrapper>
)

export default ScannerView
